<template>
    <div class="content-heading">
        <i class="ic-head-icon">
            <img src="@/assets/images/sidebar/estore.svg" alt="Vouchers Icon">
        </i>
        <h4 class="head-title">Vouchers</h4>
        <!-- <i class="ic-tooltip" id="help"></i>
        <b-popover target="help"
                triggers="hover"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.">
        </b-popover> -->
        <div class="head-tabs">
            <b-nav tabs>
                <b-nav-item 
                    :to="{ path: '/vouchers'}"
                    v-if="permission.hasAccess('vouchers:topup.vouchers:topup-vouchers')"
                >
                    Vouchers
                </b-nav-item>
            </b-nav>
        </div>
    </div>
</template>

<script>
import permission from "../../services/user.permission";
import { mapState } from "vuex";
export default {
    name: "vouchers-nav",
    data() {
        return {
            msg: "Vouchers Nav",
            permission: permission
        };
    }
};
</script>

<style scoped>
</style>
